/* THIS FILE IS GENERATED. DO NOT EDIT */

import type { DynamicStandaloneExtras, PropsFromComponent } from '@/types/component';
import { withStandaloneInstanceof } from '@/utils/withInstanceofProp';
import { mergeProps } from '@/utils/merge';
import { ErrorBoundary } from 'base/components/ErrorBoundary';
import { StandaloneShowHero as ResolvedStandaloneShowHero } from 'base/components/standalone/ShowHero';

export const ShowHero: typeof ResolvedStandaloneShowHero = withStandaloneInstanceof((props) => {
    return (
        <ErrorBoundary>
            <ResolvedStandaloneShowHero {...props} />
        </ErrorBoundary>
    );
});

export type ShowHeroProps = PropsFromComponent<typeof ShowHero>;

/** @deprecated Use slot architecture instead */
export const ShowHeroWith = (extras: DynamicStandaloneExtras): typeof ShowHero => {
    return function ShowHero(props) {
        const theme = extras.theme.useTheme(extras.theme.key || 'ShowHero');
        return <ResolvedStandaloneShowHero {...mergeProps({ options: { theme } }, props)} />;
    }
}